var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('inspection-form-form',{attrs:{"loading":_vm.loading,"inspectionFormData":_vm.inspectionForm,"formErrors":_vm.formErrors},on:{"inspectionFormSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }